import React from 'react';

import { useTranslation } from 'react-i18next';
import { Tabs, Tab, Box } from '@mui/material';
import PageHeader from '../../../components/PageHeader/PageHeader';
import CustomTabPanel from '../../../components/Tab/CustomTabPanel';
import StaffAssignment from './StaffAssignment';
import StaffCalendar from './StaffCalendar';

const StaffLocation = () => {

  const { t } = useTranslation();
  const [tabValue, setTabValue] = React.useState(0);

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleChangeTab} aria-label="basic tabs example">
          <Tab label={t('staff')} />
          <Tab label={t('schedule')} />
        </Tabs>
      </Box>

      <CustomTabPanel value={tabValue} index={0}>
        <PageHeader title={t('staff')} subtitle={t('manage_staff')} />
        <StaffAssignment/>
      </CustomTabPanel>
      
      <CustomTabPanel value={tabValue} index={1}>
        <PageHeader title={t('schedule')} subtitle={t('manage_schedule')} />
        <StaffCalendar/>
      </CustomTabPanel>
    </>
  );
};

export default StaffLocation;